import http from "../../httpService";
import { apiUrl } from "../../../../config.js";

const apiEndpoint = apiUrl + "/setup/crm-setup/";

export function getServices() {
  return http.get(apiEndpoint + "services");
}

export function saveService(service) {
  return httpSaveData("service", service);
}

export function deleteService(serviceID) {
  return http.delete(apiEndpoint + "service/" + serviceID);
}

export function getPriorities() {
  return http.get(apiEndpoint + "priorities");
}

export function savePriority(priority) {
  return httpSaveData("priority", priority);
}

export function deletePriority(priorityID) {
  return http.delete(apiEndpoint + "priority/" + priorityID);
}

export function getIMAPEmails() {
  return http.get(apiEndpoint + "imapemails");
}

export function saveIMAPEmail(imapemail) {
  return httpSaveData("imapemail", imapemail);
}

export function deleteIMAPEmail(imapemailID) {
  return http.delete(apiEndpoint + "imapemail/" + imapemailID);
}

export function getIMAPEmail(iMAPEmailID) {
  return http.get(apiEndpoint + "iMAPEmail-detail/" + iMAPEmailID);
}

export function getServiceAgreements() {
  return http.get(apiEndpoint + "serviceagreements");
}

export function saveServiceAgreement(serviceagreement) {
  return httpSaveData("serviceagreement", serviceagreement);
}

export function deleteServiceAgreement(serviceagreementID) {
  return http.delete(apiEndpoint + "serviceagreement/" + serviceagreementID);
}

export function getServiceAgreement(serviceAgreementID) {
  return http.get(
    apiEndpoint + "serviceAgreement-detail/" + serviceAgreementID
  );
}

export function getBlockedEmails() {
  return http.get(apiEndpoint + "blockedemails");
}

export function saveBlockedEmail(blockedEmail) {
  return httpSaveData("blockedemail", blockedEmail);
}

export function deleteBlockedEmail(blockedEmailID) {
  return http.delete(apiEndpoint + "blockedemail/" + blockedEmailID);
}

export function getSalesLifeCycleStatus() {
  return http.get(apiEndpoint + "sales-life-cycle-status");
}

export function saveSalesLifeCycleStatus(slc) {
  return httpSaveData("sales-life-cycle-status", slc);
}

export function deleteSalesLifeCycleStatus(salesLifeCycleStatusID) {
  return http.delete(
    apiEndpoint + "sales-life-cycle-status/" + salesLifeCycleStatusID
  );
}

export function saveSalesLifeCycleStatusOrder(statusOrder = []) {
  return http.put(apiEndpoint + "sales-life-cycle-status-order", statusOrder);
}

function httpSaveData(path, data) {
  if (data.ID === 0) {
    return http.post(apiEndpoint + path, data);
  } else {
    return http.put(apiEndpoint + path, data);
  }
}

export function getSalesActivities() {
  return http.get(apiEndpoint + "sales-activities");
}

export function saveSalesActivity(salesActivity) {
  return httpSaveData("sales-activity", salesActivity);
}

export function deleteSalesActivity(salesActivityID) {
  return http.delete(apiEndpoint + "sales-activity/" + salesActivityID);
}
